import { apiService as api } from './api';
import { Manutencao, Paginacao } from '../types';

// Interfaces para respostas da API
export interface ManutencoesResponse {
  success: boolean;
  data: Manutencao[];
  pagination: Paginacao;
  message?: string;
}

export interface ManutencaoResponse {
  success: boolean;
  data: Manutencao;
  estatisticas?: any;
  message?: string;
}

export interface DeleteResponse {
  success: boolean;
  message: string;
}

export interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

// Filtros para listagem
export interface ManutencoesFilters {
  veiculo_id?: string;
  tipo?: string;
  status?: string;
  data_inicio?: string;
  data_fim?: string;
  valor_min?: string;
  valor_max?: string;
  sort_by?: string;
  sort_order?: string;
  per_page?: number;
  page?: number;
}

export const manutencoesService = {
  // Listar manutenções com filtros
  getManutencoes: async (filters: ManutencoesFilters = {}): Promise<ManutencoesResponse> => {
    const params = new URLSearchParams();
    
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== '') {
        params.append(key, value.toString());
      }
    });

    const response = await api.get<ManutencoesResponse>(`/v1/manutencoes?${params.toString()}`);
    return response;
  },

  // Buscar manutenção por ID
  getManutencao: async (id: number): Promise<ManutencaoResponse> => {
    const response = await api.get<ManutencaoResponse>(`/v1/manutencoes/${id}`);
    return response;
  },

  // Criar nova manutenção
  createManutencao: async (manutencao: Partial<Manutencao>): Promise<ManutencaoResponse> => {
    const response = await api.post<ManutencaoResponse>('/v1/manutencoes', manutencao);
    return response;
  },

  // Atualizar manutenção
  updateManutencao: async (id: number, manutencao: Partial<Manutencao>): Promise<ManutencaoResponse> => {
    const response = await api.put<ManutencaoResponse>(`/v1/manutencoes/${id}`, manutencao);
    return response;
  },

  // Excluir manutenção
  deleteManutencao: async (id: number): Promise<DeleteResponse> => {
    const response = await api.delete<DeleteResponse>(`/v1/manutencoes/${id}`);
    return response;
  },

  // Listar manutenções de um veículo específico
  getByVeiculo: async (veiculoId: number, filters: ManutencoesFilters = {}): Promise<ManutencoesResponse> => {
    const params = new URLSearchParams();
    
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== '') {
        params.append(key, value.toString());
      }
    });

    const response = await api.get<ManutencoesResponse>(`/v1/manutencoes/veiculo/${veiculoId}?${params.toString()}`);
    return response;
  },

  // Obter estatísticas de manutenções
  getEstatisticas: async (filters: ManutencoesFilters = {}): Promise<ApiResponse<any>> => {
    const params = new URLSearchParams();
    
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== '') {
        params.append(key, value.toString());
      }
    });

    const response = await api.get<ApiResponse<any>>(`/v1/manutencoes/estatisticas?${params.toString()}`);
    return response;
  },
};
